import {
    defaultFilterTypes,
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../types/lists/listTypes';
import {
    ISupplementDetailState,
    SupplementAppliesTo,
    SupplementFilterState,
} from '../../types/supplement/supplementsTypes';
import { TagColor } from '../../muiComponents/Tag';

export const getSupplementsInitialStateFilters = (
    timezone: string
): SupplementFilterState => ({
    Name: {
        filterType: defaultFilterTypes.DEFAULT_STRING_FILTER_TYPE,
        filterKey: 'Name',
        value: '',
    },
    IdSupplierHotel: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotel',
    },
    IdSupplierHotelRoomType: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotelRoomType',
    },
    IdSupplierHotelMealPlan: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotelMealPlan',
    },
    IdSupplierHotelRatePlan: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_INTEGER_ID_FILTER_TYPE,
        filterKey: 'IdSupplierHotelRatePlan',
    },
    FromDate: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_FROM_FILTER_TYPE,
        filterKey: 'FromDate',
        timeZone: timezone,
    },
    ToDate: {
        value: null,
        filterType: defaultFilterTypes.DEFAULT_DATE_TIME_TO_FILTER_TYPE,
        filterKey: 'ToDate',
        timeZone: timezone,
    },
});

export const filterSingleColumnGrid = { xs: 12, sm: 12, md: 6, lg: 3, xl: 3 };
export const filterDoubleColumnGrid = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };

export const supplementCardGrid = { xs: 12, sm: 6, md: 6, lg: 3, xl: 3 };

export const panelColumnsSpacing = {
    xs: '30px',
    sm: '30px',
    lg: '30px',
    xl: '30px',
};

export const panelRowsSpacing = {
    xs: '30px',
    sm: '30px',
    lg: '30px',
    xl: '30px',
};

export const supplementsTableColumns: ITableHeaderColumn[] = [
    {
        id: 'Enabled',
        labelText: 'enabled',
        titleText: 'enabled',
    },
    {
        id: 'Name',
        labelText: 'name',
        titleText: 'name',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotel/Name',
        labelText: 'hotel',
        titleText: 'hotel',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotel/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelRoomType/Name',
        labelText: 'room',
        titleText: 'room',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelRoomType/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelMealPlan/Name',
        labelText: 'meal_plan',
        titleText: 'meal_plan',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelMealPlan/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelRatePlan/Name',
        labelText: 'rate_plan',
        titleText: 'rate_plan',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelRatePlan/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    { id: 'Type', labelText: 'type', titleText: 'type' },
    {
        id: 'FromDate',
        labelText: 'dates',
        titleText: 'dates',
    },
];

export const SUPPLEMENT_DATE_TAG_COLOR: Record<string, TagColor> = {
    old: 'cyan',
    current: 'green',
    upcoming: 'purple',
    dateless: 'yellow',
};

export const SUPPLEMENT_INITIAL_STATE: ISupplementDetailState = {
    Id: '',
    Enabled: true,
    Name: '',
    Description: '',
    FromDate: null,
    ToDate: null,
    IdSupplierHotel: 0,
    SupplierHotel: '',
    IdSupplierHotelRoomType: 0,
    IdSupplierHotelMealPlan: 0,
    IdSupplierHotelRatePlan: 0,
    SupplierHotelRoomType: '',
    SupplierHotelMealPlan: '',
    SupplierHotelRatePlan: '',
    Amount: 0,
    IdCurrency: 0,
    Currency: '',
    EffectivePerson: 0,
    OnlyAdults: false,
    OnlyChildren: false,
    Priority: 0,
    IdSupplementCalculationType: 0,
    SupplementCalculationType: '',
    IdSupplierTaxCalculationRuleType: 0,
    SupplierTaxCalculationRuleType: '',
    SupplierTaxCalculationRuleTypeKey: '',
    IdSupplierTaxCalculationType: 0,
    SupplierTaxCalculationType: '',
    SupplierTaxCalculationTypeKey: '',
    FromAge: 0,
    ToAge: 0,
};

export const SUPPLEMENT_PANEL_VALIDATION_INITIAL_STATE = {
    isValidated: false,
    Name: '',
    IdSupplierHotel: '',
    ToDate: '',
    IdSupplierTaxCalculationType: '',
    IdSupplementCalculationType: '',
    AppliesBy: '',
    Frequency: '',
    IdCurrency: '',
    Amount: '',
};

export const AppliersToIcons = {
    ALL: 'FamilyRestroom',
    ONLY_ADULTS: 'Wc',
    ONLY_CHILDREN: 'fa-solid fa-child-reaching',
};

export const appliesToOptions = [
    { value: SupplementAppliesTo.ALL, label: 'All', icon: AppliersToIcons.ALL },
    {
        value: SupplementAppliesTo.ONLY_ADULTS,
        label: 'Only adults',
        icon: AppliersToIcons.ONLY_ADULTS,
    },
    {
        value: SupplementAppliesTo.ONLY_CHILDREN,
        label: 'Only children',
        icon: AppliersToIcons.ONLY_CHILDREN,
        iconStyle: { fontSize: '20px' },
    },
];
